export default class Epar {
	marketingAuthorisationDate: Date | null;

	constructor(marketingAuthorisationDate: Date | null) {
		this.marketingAuthorisationDate = marketingAuthorisationDate;
	}
}
